<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
				<div class="col-12 col-lg-8 pl-0 pr-0 pr-lg-3">
					<!-- <transition name="slide-fade">
						<rdc v-if="step == 0"></rdc>
					</transition> -->
					<transition name="slide-fade">
						<product v-if="step == 0"></product>
					</transition>
					<transition name="slide-fade">
						<payment-method ref="payment" v-if="step == 1"></payment-method>
					</transition>
					<transition name="slide-fade">
						<success v-if="step == 2"></success>
					</transition>
				</div>
				<div class="col-12 col-lg-4 pl-0 pr-0 pt-3 pt-lg-0">
					<cart :alert="alert"></cart>
				</div>
			</div>
		</div>

		<i-modal ref="modalAlertSerial" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal :message="alertKeranjang" type="alert" @remove="removeAlert"/>
				<!-- <div class="text-center">
					<h4>{{alertKeranjang}}</h4>
					<button @click="() => { setAlertKeranjang('') }"> OK</button>
				</div> -->
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>

		<i-modal ref="modalConfirmation" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi" :message="confirmMessage" type="confirmation" @remove="resetConfirmMessage" @confirm="confirm"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
	</div>
</template>

<script>
//import carousel from 'vue-owl-carousel';
//import MitraCode from '@/views/transaction/MitraCode.vue';
//import Rdc from '@/views/po/Rdc.vue';
import Cart from '@/views/po/Cart.vue';
import Product from '@/views/po/Product.vue';
//import Serial from '@/views/transaction/Serial.vue';
import PaymentMethod from '@/views/po/PaymentMethod.vue';
//import FormMitra from '@/views/transaction/FormMitra.vue';
import Success from '@/views/po/Success.vue';

import IModal from '@/components/IModal.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

export default {
	components: {
		//carousel, Cart, Serial, PaymentMethod, FormMitra, Product, MitraCode, IModal, AlertModal
		Cart, PaymentMethod, Product, IModal, AlertModal, Success, //Rdc
	},
	name: 'Transaction',
	data() {
		return {
			selectedProduct: {},
			nama_produk : '',
			deskripsi_produk : '',
			product_image : '',
			confirmMessage: '',
			registrationData: {
				mitra_code: '',
				email: '',
				name: '',
				card_id: '',
				mobilephone: '',
			},
			alert: {
				mitra_code: '',
				email: '',
				name: '',
				card_id: '',
				mobilephone: '',
			},
			tempMitra: true,
		}
	},
	computed: {
		...mapState('po_cart', ['dataProduk', 'qty_product', 'step', 'cart', 'alertKeranjang', 'mitra']),
		...mapState('auth', ['userData']),
		...mapGetters('auth', ['isAuth']),
	},
	methods:{
		...mapActions('registrasiList', ['registrasiStockist']),
		...mapActions('po_cart', ['saveCart', 'changeProductQty', 'getregisterItem']),
		...mapMutations('po_cart', ['setMitra', 'step_up', 'step_down', 'setAlertKeranjang', 'reset']),

		async chooseMitra(val) {
			this.tempMitra = val
			if (val !== this.mitra) {
				if ([1,2,3].includes(this.step)) {
					var tipe = ''
					if (this.tempMitra) {
						tipe = 'Mitra'
					} else {
						tipe = 'Mitra Baru'
					}
					this.confirmMessage = `Anda yakin ingin melakukan transaksi ${tipe}?`
				} else {
					await this.reset()
					if (!this.tempMitra) {
						this.getregisterItem()
					}
					this.setMitra(this.tempMitra)
				}
			}
			// if (this.step == 0) {
			// 	this.reset()
			// 	this.setMitra(val)
			// 	if (!val) {
			// 		this.getregisterItem()
			// 	}
			// } else {
			// 	return false;
			// }
		},
		removeAlert() {
			this.setAlertKeranjang('')
			if (this.step > 2) {
				this.$refs.payment.setFocus()
			} else if (this.step == 2) {
				this.$refs.componentSerial.focusOnInput()
			}
		},
		resetConfirmMessage() {
			this.confirmMessage = ''
		},
		async confirm() {
			await this.reset()
			if (!this.tempMitra) {
				this.getregisterItem()
			}
			this.resetConfirmMessage()
			this.setMitra(this.tempMitra)
		}
	},
	watch: {
		alertKeranjang(val){
			if (val) {
				this.$refs.modalAlertSerial.modalShow()
			} else {
				this.$refs.modalAlertSerial.modalHide()
			}
		},
		confirmMessage(val){
			if (val) {
				this.$refs.modalConfirmation.modalShow()
			} else {
				this.$refs.modalConfirmation.modalHide()
			}
		},
		step(val, old){
			if (val == 0 && old != 1) {
				this.reset()
			}
		}
	},
	created () {
		this.$store.dispatch('setPageTitle', 'Belanja Produk');
	},
	beforeDestroy(){
		this.reset()
	}
};
</script>
